import { userAxios } from "../index";

/**
 * Servicio para obtener los pacientes disponibles para el agente de seguros.
 */
const getAgentUsers = async (params) =>
  userAxios
    .get("/insurance/agent-data/get-users", { params })
    .then((response) => response.data);

/**
 * Servicio que devuelve la información agregada del dashboard del agente.
 * Requiere start_date, end_date opcionales patient_id y type_insurance.
 */
const getDashboardData = async (payload) =>
  userAxios
    .post("/insurance/dashboard-agent-data", payload)
    .then((response) => response.data);

export default {
  getAgentUsers,
  getDashboardData,
};

